import { render, staticRenderFns } from "./couponsmng.vue?vue&type=template&id=01a16c24&scoped=true"
import script from "./couponsmng.vue?vue&type=script&lang=js"
export * from "./couponsmng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a16c24",
  null
  
)

export default component.exports